import Vue from 'vue'
import VueQrcodeReader from 'vue-qrcode-reader'
import VueClipboard from 'vue-clipboard2'
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })
Vue.use(VueQrcodeReader)
Vue.use(VueClipboard)
Vue.use(VCalendar)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js